import angular from 'angular';
import delegationsListComponent from './delegationsList.component';
import delegationCard from './delegationCard/delegationCard';

let delegationsListModule = angular.module('delegationsList', [
  delegationCard
])

.component('delegationsList', delegationsListComponent)

.name;

export default delegationsListModule;



// WEBPACK FOOTER //
// ./client/app/components/delegationsList/delegationsList.js